import { useEffect, useRef, useState } from "react";

// threshold is a primitive so it is safe in the dep array.
// Using a plain number avoids the common bug where passing an options
// object literal as a default creates a new reference on every render,
// causing the effect to re-run and thrash the IntersectionObserver.
export default function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref, inView];
}
